import { Injectable } from '@angular/core';
import { ApplicationActions } from '../../actions/application.actions';
import moment from 'moment';

@Injectable()
export class TimeService {
  constructor(applicationActions: ApplicationActions) {
    this.appActions = applicationActions;
    this.holidays = {
      M: {
        // Month, Day
        '01/01': 'New Year\'s Day',
        '06/19': 'Juneteenth National Independence Day',
        '07/04': 'Independence Day',
        '11/11': 'Veteran\'s Day',
        '12/25': 'Christmas Day',
      },
      W: {
        // Month, Week of Month, Day of Week
        '1/4/1': 'Martin Luther King Jr. Day',
        '2/3/1': 'Washington\'s Birthday',
        '5/5/1': 'Memorial Day',
        '9/2/1': 'Labor Day',
        '10/3/1': 'Columbus Day',
        '11/4/4': 'Thanksgiving Day',
      },
    };
    // Intentional commented lines
    //  Refer the FedACH Holiday Schedule processing time on https://www.frbservices.org/about/holiday-schedules and update the half days accordingly
    this.halfDays = {
      M: {
        // Month, Day
        // '07/03': 'Independence Day',
        // '12/24': 'Christmas Eve',
      },
      W: {
        // Month, Week of Month, Day of Week
        // '11/4/5': 'Black Friday',
      },
    };
  }

  // Is it  Daylight Saving Time
  dst() {
    const date = new Date();
    return date.getTimezoneOffset() < this.stdTimezoneOffset();
  }

  stdTimezoneOffset() {
    const fullYear = new Date().getFullYear();
    const jan = new Date(fullYear, 0, 1);
    const jul = new Date(fullYear, 6, 1);
    return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
  }

  checkDate(date, list = this.holidays) {
    const diff = 1 + (0 | ((new Date(date).getDate() - 1) / 7));
    const memorial =
      new Date(date).getDay() === 1 && new Date(date).getDate() + 7 > 30
        ? '5'
        : null;

    return (
      list.M[moment(date).format('MM/DD')] ||
      list.W[moment(date).format('M/' + (memorial || diff) + '/d')]
    );
  }

  isWeekend(date) {
    const dow = moment(date).weekday();
    return dow === 0 || dow === 6;
  }

  getNextBusinessDay(date) {
    const nextDay = moment(date).add(1, 'days');

    if (this.checkDate(nextDay)) {
      return this.getNextBusinessDay(nextDay);
    }

    if (this.isWeekend(nextDay)) {
      return this.getNextBusinessDay(nextDay);
    }

    return nextDay;
  }

  getDepositDate(isOneAlly) {
    let offset = 5;
    // Is it day light saving
    if (this.dst()) {
      offset = 4;
    }

    let afterHours = isOneAlly
      ? moment(
          moment().format(`MM/DD/YYYY [3:55:00 PM -0${offset}00]`),
          'MM/DD/YYYY HH:mm:ss A ZZ'
        )
      : moment(
          moment().format(`MM/DD/YYYY [2:55:00 PM -0${offset}00]`),
          'MM/DD/YYYY HH:mm:ss A ZZ'
        );

    if (!isOneAlly && this.checkDate(moment(), this.halfDays)) {
      afterHours = moment(
        moment().format(`MM/DD/YYYY [12:55:00 PM -0${offset}00]`),
        'MM/DD/YYYY HH:mm:ss A ZZ'
      );
    }

    if (moment().isBefore(afterHours)) {
      return moment().format('MM/DD/YYYY');
    } else {
      this.appActions.setData('DepositFunds.isAfterHours', true);
      return this.getNextBusinessDay(moment()).format('MM/DD/YYYY');
    }
  }

  getCurrentDateMin() {
    return moment().format('M/DD/YYYY,hh');
  }

  getCurrentMinSec() {
    return moment().format('mm.ss');
  }
}
